import React from 'react';
import { RetroProvider } from './src/components/retro/retro-context';

export const wrapRootElement = ({ element }) => {
  return <RetroProvider>{element}</RetroProvider>;
};
